import React, { useState } from "react";
import { calendarDateTimetoDate, formatDateTimeFromTimestamp } from "../../helpers/date/date-helper";
import { DateRangePicker } from "@heroui/react";
import { ActionButton } from "../buttons/ActionButton";


export const DateRangePickerComponent = ({ defaultStart, defaultEnd, trigger, callback, allowInPast=true,
                                           validateText='Valider', cancelText='Annuler' }) => {

  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const defaultRange = {start: defaultStart, end: defaultEnd}

  const [draftRange, setDraftRange] = useState({
    start: formatDateTimeFromTimestamp(defaultRange.start),
    end: formatDateTimeFromTimestamp(defaultRange.end),
  });
  const isDraftInPast = (() => {
    if (!draftRange?.start) return true;
    const startTs = calendarDateTimetoDate(draftRange.start).getTime();
    return startTs <= Date.now();
  })();

  return (
    <div className="relative">
      {trigger({ isCalendarOpen, setIsCalendarOpen })}

      <DateRangePicker
        isOpen={isCalendarOpen}
        onOpenChange={setIsCalendarOpen}
        value={{ start: draftRange.start, end: draftRange.end }}
        onChange={({ start, end }) => setDraftRange({ start, end })}
        CalendarBottomContent={
          <div className="flex justify-end gap-2 p-4 pt-0">
            <ActionButton text={cancelText} color="cancel" onClick={() => setIsCalendarOpen(false)} size="sm"/>
            <ActionButton
              text={validateText} size="sm" disabled={!draftRange?.start || !draftRange?.end || (!allowInPast && isDraftInPast)}
              onClick={() => {
                callback?.(calendarDateTimetoDate(draftRange?.start), calendarDateTimetoDate(draftRange?.end))
                setIsCalendarOpen(false);
              }}
            />
          </div>
        }
        classNames={{
          base: "p-0",
          inputWrapper: "p-0 min-h-0 h-auto bg-transparent",
          selectorButton: "hidden",
          innerWrapper: "absolute w-0 h-0 overflow-hidden opacity-0 pointer-events-none",
          segment: "hidden",
          separator: "hidden",
          input: "w-0 h-0 p-0 m-0 opacity-0",
          label: "hidden",
        }}
        className="absolute left-0 top-0 w-0 h-0 overflow-hidden p-0 m-0"
        radius="none"
        granularity="minute"
        label={null}
      />
    </div>
  );
};